import { useTranslation } from 'react-i18next';
import { MarketActionCard } from '@market/react';
import CardLogo from 'typescript/apps/checkout_v3/components/payment/saved_cards/card_logo';
import { WalletPaymentSource } from 'typescript/types/api/payment_sources';
import styles from 'typescript/apps/checkout_v3/components/payment/saved_cards/selected_saved_card.module.scss';

interface SelectedSavedCardProps {
  selectedCard?: WalletPaymentSource;
  usePostalCode?: boolean;
  onCardClicked?: (event: any) => void;
}

const SelectedSavedCard = ({
  selectedCard = null,
  usePostalCode = false,
  onCardClicked,
}: SelectedSavedCardProps) => {
  if (selectedCard === null) {
    return null;
  }

  const { t } = useTranslation();

  return (
    <MarketActionCard
      className={
        selectedCard.default
          ? styles.selectedCardDefault
          : styles.selectedCardNotDefault
      }
      onMarketCardDeselected={onCardClicked}
      selected={true}
      data-testid="selected-saved-card"
    >
      <div className={styles.gridContainer}>
        <div className={styles.oneColumnWidth}>
          <CardLogo brand={selectedCard.payment_source.brand} />
        </div>
        <div
          className={`${styles.cardNumberSection} ${styles.fiveColumnWidth}`}
        >
          <p className="semibold-20">
            {String(t('checkout.payment.selectedCard.cardNumber'))}
          </p>
          <p className="paragraph-30">
            •••• •••• •••• {selectedCard.payment_source.last_digits}
          </p>
        </div>
        <div
          className={
            usePostalCode ? styles.twoColumnWidth : styles.threeColumnWidth
          }
        >
          <p className="semibold-20">
            {String(t('checkout.payment.selectedCard.expiration'))}
          </p>
          <p className="paragraph-30">
            {selectedCard.payment_source.month}/
            {selectedCard.payment_source.year}
          </p>
        </div>
        <div
          className={
            usePostalCode ? styles.twoColumnWidth : styles.threeColumnWidth
          }
        >
          <p className="semibold-20">
            {String(t('checkout.payment.selectedCard.cvv'))}
          </p>
          <p className="paragraph-30">•••</p>
        </div>
        {usePostalCode && (
          <div className={styles.twoColumnWidth}>
            <p className="semibold-20">ZIP</p>
            <p className="paragraph-30">
              {selectedCard.payment_source.postal_code.trim().split('-')[0]}
            </p>
          </div>
        )}
      </div>
    </MarketActionCard>
  );
};

export default SelectedSavedCard;
